module.exports = __webpack_public_path__ + "img/ipBg.983e93ed.png";